import React, { Component } from 'react';
import {
  Button,
  Dialog,
  // DialogTitle,
  DialogContent,
  DialogActions,
  withStyles,
  // Typography,
  // Container,
  Grid,
  Typography,
  // Checkbox,
} from '@material-ui/core';
import { EVENT_IMG } from '../../constants';
const styles = (theme) => ({
  dialogRoot: {},
  contentOuter: {
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      height: '596px',
    },
  },
  title: {
    paddingBottom: '0px',
  },
  titleText01: {
    color: theme.palette.primary.main,
    fontWeight: '900',
    // fontSize: '28px',
    fontSize: '22px',
    margin: 0,
    wordBreak: 'keep-all',
    wordWrap: 'break-word',
  },
  titleText02: {
    fontSize: '15.5px',
    //textAlign: 'center',
    margin: '3px 0px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13.5px',
    },
  },
  image: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  eventTxt: {
    fontWeight: 500,
    fontSize: '16px',
    color: '#555',
    wordBreak: 'keep-all',
    margin: '14px 0',
  },
  scoreList: {
    paddingLeft: '15px',
    '& li': {
      textIndent: '-5px',
    },
    '& li:before': {
      content: '"-"',
      textIndent: '-5px',
    },
  },
  agreeBtn: {
    minWidth: '50%',
    fontWeight: 'bold',
    color: '#fff',
    padding: '15px 0',
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0px',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '0px',
      minWidth: '100%',
    },
  },
});

class EventDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: true,
    };
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes, open, onClose } = this.props;
    return (
      <Dialog
        maxWidth={'md'}
        onClose={onClose}
        open={open}
        // disableBackdropClick={disableBackdrop}
        // disableEscapeKeyDown={disableBackdrop}
        className={classes.dialogRoot}
      >
        {/* <div
          className={classes.contentOuter}
          style={
            window.matchMedia('(max-width: 600px)').matches
              ? { textAlign: 'center', paddingTop: '4px' }
              : { textAlign: 'center', padding: '4px 0 20px' }
          }
        > */}
        <DialogContent>
          <Grid container justify="center" style={{ marginBottom: '10px' }}>
            {/* <div>
              <p className={classes.titleText01}>5시가</p>
            </div> */}
          </Grid>

          <Grid container justifyContent="center">
            <Grid onClick={() => window.open(`/#/live?ch=Channel01`, 'liveWin')}>
              <img
                src={`${EVENT_IMG}/evt_lobby.png`}
                alt={'event'}
                className={classes.image}
                style={{ width: '100%', cursor: 'pointer' }}
              />
            </Grid>
          </Grid>

          <Grid container justifyContent="center" style={{ padding: '2vh 0' }}>
            <Typography style={{ fontSize: 'large', wordBreak: 'keep-all' }}>
              {/* <b>Channel 1</b>에서&nbsp;<b>5시간 이상 수강자</b>&nbsp;경품 추첨이 진행됩니다. <br /> */}
              <b>이미지를 클릭</b>해 주시기 바랍니다.
            </Typography>
          </Grid>
        </DialogContent>
        <DialogActions
        // style={window.matchMedia('(max-width: 960px)').matches ? { display: 'block', padding: 0 } : { display: 'none' }}
        >
          <Grid container justify="center" alignItems="center">
            <Button onClick={onClose} color="primary" variant="contained" size="large" className={classes.agreeBtn} disableElevation>
              닫기 ( Close )
            </Button>
          </Grid>
        </DialogActions>
        {/* </div> */}
      </Dialog>
    );
  }
}
export default withStyles(styles, { withTheme: true })(EventDialog);
